import type { SerializedError } from '@reduxjs/toolkit';

export class ThunkSerializableError extends Error implements SerializedError {
  constructor(message: string, name: string) {
    super(message);
    this.name = name;
    this.message = message;
  }
}

export const MISSING_CATEGORY_ID_ERROR = new ThunkSerializableError(
  'No category ID was specified in the content',
  'MISSING_CATEGORY_ID',
);

export const MISSING_LISTINGS_QUERY_ERROR = new ThunkSerializableError(
  'listings_query missing for category listing page',
  'MISSING_LISTINGS_QUERY',
);

export const CATEGORY_NOT_FOUND_ERROR = new ThunkSerializableError(
  'The requested category was not found',
  'CATEGORY_NOT_FOUND',
);

export const PARTNER_NOT_FOUND_ERROR = new ThunkSerializableError(
  'The requested partner was not found',
  'PARTNER_NOT_FOUND',
);

export const PRODUCTS_LIST_DATA_FETCHING_ERROR = new ThunkSerializableError(
  'There was an error fetching the products list',
  'PRODUCTS_LIST_DATA_FETCHING_ERROR',
);

export const serializeError = (error: ThunkSerializableError): SerializedError => {
  return {
    name: error.name,
    message: error.message,
  };
};
